import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material';

interface BillingAccountDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (shiftWorkLogs: boolean) => void;
  selectedAccount?: {
    name: string;
    _id: string;
  };
}

const BillingAccountDialog: React.FC<BillingAccountDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedAccount,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle variant="h5" sx={{ fontWeight: 'bold' }}>
      Confirm Work Logs Change
    </DialogTitle>
    <DialogContent>
      {/* <DialogContentText>
        Are you sure you want to change the billing account to &quot;
        {selectedAccount?.name}&quot;?
      </DialogContentText> */}
      <DialogContentText sx={{ mt: 2 }}>
        Do you want to change the account in the work logs as well?
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Box>
        <Button
          onClick={() => onConfirm(false)}
          color="primary"
          variant="outlined"
          sx={{ mr: 1 }}>
          No
        </Button>
        <Button
          onClick={() => onConfirm(true)}
          color="secondary"
          variant="contained">
          Yes
        </Button>
      </Box>
    </DialogActions>
  </Dialog>
);

export default BillingAccountDialog;
